<template>
  <div class="gp-main-body-content">
    <Tabs @tabChange="onTabChangeHandler" :active="currentTab" :header="true">
      <template v-slot:GpTab="{ activeIndex, handler }">
        <Tab v-for="(tab, index) in tabs" :key="'tab-item' + index" :index="tab.index" :activeIndex="activeIndex" @click="handler">
          <p class="d-flex align-items-center">
            <span>{{ $t(tab.name) }}</span>
          </p>
        </Tab>
      </template>
      <template v-slot:GpTabContent="{ activeIndex, animate }">
        <Content :index="tabs[0].index" :animate="animate" :activeIndex="activeIndex">
          <StoreGeneralSettings></StoreGeneralSettings>
        </Content>
        <Content :index="tabs[1].index" :animate="animate" :activeIndex="activeIndex">
          <EventLog></EventLog>
        </Content>
      </template>
    </Tabs>
  </div>
</template>

<script>
import Tabs, { GpTab as Tab, GpTabContent as Content } from "@/core/shared/GpTabs";
import { StoreGeneralSettings, EventLog } from "../components";

export default {
  name: "StoreSettings",
  components: {
    StoreGeneralSettings,
    EventLog,
    Tabs,
    Tab,
    Content
  },
  data: () => ({
    prevRoute: null,
    currentTab: ""
  }),
  computed: {
    tabs() {
      return [
        {
          name: "storeSettings.general.title",
          index: "#general"
        },
        {
          name: "storeSettings.eventLogs.title",
          index: "#eventlog"
        }
      ];
    }
  },
  async created() {
    const tab = this.$route.hash;
    const found = this.tabs.find(item => item.index == tab);
    if (found) {
      this.currentTab = tab;
    } else {
      this.currentTab = this.tabs[0].index;
    }
  },
  methods: {
    onTabChangeHandler(index) {
      this.currentTab = index;
      this.$router.replace({
        name: "StoreSettings",
        hash: index
      });
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  }
};
</script>

<style lang="scss" scoped>
// Dragon said: "border top 1 solid text dark mode high" =)))))
.bt1stdmh {
  border-top: 1px solid $textDarkModeHigh;
}

.setting {
  margin-top: 24px;

  &-block {
    .block {
      background: $neutral5;
      height: 100%;

      .icon {
        img {
          width: 40px;
          height: auto;
        }
      }
    }

    .form-group {
      margin-top: 0px !important;
      padding-top: 24px;

      .form-group {
        padding-top: 0px;
      }
    }

    &:not(:first-child) {
      padding-top: 24px;
    }
  }
}

.center {
  align-items: center;
}

button {
  height: 40px;
  min-width: 160px;
}

.pwd {
  a {
    &:hover {
      display: none;
    }
  }
}

@keyframes highlight {
  0% {
    box-shadow: 0 0 5px 0px $accent-red;
  }
  25% {
    box-shadow: 0 0 15px 2px $accent-red;
  }
  50% {
    box-shadow: 0 0 5px 0px $accent-red;
  }
  75% {
    box-shadow: 0 0 15px 2px $accent-red;
  }
  100% {
    box-shadow: 0 0 5px 0px $accent-red;
  }
}

.highlight {
  animation: highlight 1.5s alternate ease-out 2;
}
</style>
